export const goToUrl = (url: string, target = '_self') => {
    if (url) {
        window.open(url, target);
    }
};
